import { render } from "./AdminInsights.vue?vue&type=template&id=97230342&scoped=true"
import script from "./AdminInsights.vue?vue&type=script&lang=js"
export * from "./AdminInsights.vue?vue&type=script&lang=js"

import "./AdminInsights.vue?vue&type=style&index=0&id=97230342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97230342"]])

export default __exports__